import request from 'utils/request'

// MCBHS141初期化
export const getMCBHS141InitRequest = () => 
request({
  url: '/MCBHS141/init',
  method: 'post',
})

